module.exports = __webpack_public_path__ + "static/img/step_4.2bd693a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customized_service/step_4.png
// module id = 4B4t
// module chunks = 94